export default {
  path: '/',
  component: () => import('@/components/HomeView')
}
